import { useEffect } from 'react'
import { useIsFocused } from '@react-navigation/native'
import { useDispatch } from 'react-redux'
import { setData } from 'services/redux/data/actions'
import { dataConstants } from 'services/redux/data/constants'

export const useScannerFullScreen = () => {
	const isFocused = useIsFocused();
	const dispatch = useDispatch();
	useEffect( () => {
		dispatch( setData( dataConstants.APP_FULL_WIDTH, isFocused ) );
		return () => {
			dispatch( setData( dataConstants.APP_FULL_WIDTH, false ) );
		};
	}, [ dispatch, isFocused ] );
};
